var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { hexToRgba } from "../helper";
var baseLightPalette = {
    up: '#14BDBD',
    down: '#FF6E6E',
    black: 'black',
    white: 'white',
    primary: '#14BDBD',
    secondary: '#074C5F',
    tertiary: '#409F99',
    error1: '#FF3C3E',
    error2: '#FF6E6E',
    active: '#FD9933',
    warn1: '#FD9933',
    warn2: '#FECC66',
    grey200: '#B7C2CB',
    grey100: '#D9E4E6',
    grey60: '#191919',
    grey50: '#4E4E4E',
    grey40: '#7F7F7F',
    grey31: '#9B9B9B',
    grey30: '#CCCCCC',
    grey21: '#39404E',
    grey20: '#F2F2F2',
    grey10: '#FAFAFA',
    greyBG: '#F8F8F8',
    blank: '#FFFFFF',
    defaultShadow1: '#18274B14',
    defaultShadow2: '#18274B1F',
    success: '#00E862',
    success2: '#14BDBD',
    primary50: '#FFF3F8',
    primary200: '#F6BDD3',
    primary300: '#F3A8C5',
    primary400: '#F093B7',
    primary500: '#ED7EA8',
    primary600: '#EB689A',
    primary700: '#E8538C',
};
// add extends colors
export var lightPalette = __assign(__assign({}, baseLightPalette), { extend1: hexToRgba(baseLightPalette.primary, 0.15), extend2: hexToRgba(baseLightPalette.warn2, 0.15), extend3: hexToRgba(baseLightPalette.error2, 0.15) });
var baseDarkPalette = {
    up: '#21CBCB',
    down: '#FF7777',
    black: 'black',
    white: 'white',
    primary: '#21CBCB',
    secondary: '#EBEEF4',
    tertiary: '#4EAFA9',
    error1: '#FF5658',
    error2: '#FF7777',
    active: '#FD9933',
    warn1: '#FFA74E',
    warn2: '#FFD276',
    grey200: '#83929E',
    grey100: '#B9C9CC',
    grey60: '#F9F9F9',
    grey50: '#D3D3D3',
    grey40: '#A7A7A7',
    grey31: '#7C7C7C',
    grey30: '#4B4B4B',
    grey21: '#39404E',
    grey20: '#202020',
    grey10: '#1D1D1D',
    greyBG: '#161616',
    blank: '#222222',
    defaultShadow1: '#18274B14',
    defaultShadow2: '#18274B1F',
    success: '#1EF278',
    success2: '#21CBCB',
    primary50: '#5E3F5B',
    primary200: '#803860',
    primary300: '#913562',
    primary400: '#A23265',
    primary500: '#B32F68',
    primary600: '#C42B6A',
    primary700: '#D5286C',
};
// add extends colors
export var darkPalette = __assign(__assign({}, baseDarkPalette), { extend1: hexToRgba(baseDarkPalette.primary, 0.15), extend2: hexToRgba(baseDarkPalette.warn2, 0.15), extend3: hexToRgba(baseDarkPalette.error2, 0.15) });
export var lightShadow = {
    100: "0px 4px 4px -2px #18274B14, 0px 2px 4px -2px #18274B1F",
    200: '0px 8px 8px -4px #18274B14, 0px 4px 6px -4px #18274B1F',
    300: '0px 8px 16px -6px #18274B14, 0px 6px 8px -6px #18274B1F',
    400: '0px 8px 24px -4px #18274B14, 0px 6px 12px -6px #18274B1F',
    500: '0px 10px 32px -4px #18274B14, 0px 6px 14px -6px #18274B1F',
    600: '0px 12px 42px -4px #18274B14, 0px 8px 18px -6px #18274B1F',
    700: '0px 14px 64px -4px #18274B14, 0px 8px 22px -6px #18274B1F',
    800: '0px 18px 88px -4px #18274B14, 0px 8px 28px -6px #18274B1F',
};
export var darkShadow = {
    100: "0px 4px 4px -2px rgba(0, 0, 0, 8%), 0px 2px 4px -2px rgba(0, 0, 0, 12%)",
    200: '0px 8px 8px -4px rgba(0, 0, 0, 8%), 0px 4px 6px -4px rgba(0, 0, 0, 12%)',
    300: '0px 8px 16px -6px rgba(0, 0, 0, 8%), 0px 6px 8px -6px rgba(0, 0, 0, 12%)',
    400: '0px 8px 24px -4px rgba(0, 0, 0, 8%), 0px 6px 12px -6px rgba(0, 0, 0, 12%)',
    500: '0px 10px 32px -4px rgba(0, 0, 0, 10%), 0px 6px 14px -6px rgba(0, 0, 0, 12%)',
    600: '0px 12px 42px -4px rgba(0, 0, 0, 12%), 0px 8px 18px -6px rgba(0, 0, 0, 12%)',
    700: '0px 14px 64px -4px rgba(0, 0, 0, 12%), 0px 8px 22px -6px rgba(0, 0, 0, 12%)',
    800: '0px 18px 88px -4px rgba(0, 0, 0, 14%), 0px 8px 28px -6px rgba(0, 0, 0, 12%)',
};
export var textLevel = {
    1: {
        fontSize: '12px',
        lineHeight: '16px',
    },
    2: {
        fontSize: '14px',
        lineHeight: '24px',
    },
    3: {
        fontSize: '16px',
        lineHeight: '24px',
    },
    4: {
        fontSize: '18px',
        lineHeight: '24px',
    },
    5: {
        fontSize: '20px',
        lineHeight: '24px',
    },
    6: {
        fontSize: '22px',
        lineHeight: '24px',
    },
    7: {
        fontSize: '24px',
        lineHeight: '32px',
    },
    // TODO: remove level 8, let 40px use level 15, follow (level - defaultLevel) * 2 + defaultSize
    8: {
        fontSize: '40px',
        lineHeight: '32px',
    },
    15: {
        fontSize: '40px',
        lineHeight: '32px',
    }
};
export var theme = {
    palette: lightPalette,
    shadow: lightShadow,
    textLevel: textLevel,
    curve: {
        default: 'cubic-bezier(0.15, 0.91, 0.47, 0.96)'
    },
    breakpoint: {
        tablet: 744,
        desktop1: 1280,
        desktop2: 1580,
        desktop3: 1920,
    },
};
